import { render, staticRenderFns } from "./warn_popup.vue?vue&type=template&id=40d62c78"
import script from "./warn_popup.vue?vue&type=script&lang=js"
export * from "./warn_popup.vue?vue&type=script&lang=js"
import style0 from "./warn_popup.vue?vue&type=style&index=0&id=40d62c78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports